import { Pipe, PipeTransform } from '@angular/core';
import { parsePhoneNumber, isValidPhoneNumber } from 'libphonenumber-js';

@Pipe({
  name: 'phone'
})
export class PhonePipe implements PipeTransform {
  transform(phoneValue: number | string): string {
    const stringPhone = phoneValue + '';

    if (!isValidPhoneNumber(stringPhone, 'BR')) {
      return stringPhone;
    }

    const phoneNumber = parsePhoneNumber(stringPhone, 'BR');
    const formatted = phoneNumber.formatNational();
    return formatted;
  }

  public static format(phoneValue: string | number): string {
    const stringPhone = phoneValue + '';
    
    if (!isValidPhoneNumber(stringPhone, 'BR')) {
      return stringPhone;
    }

    const phoneNumber = parsePhoneNumber(stringPhone, 'BR');
    const formatted = phoneNumber.formatNational();
    return formatted;
  }
}